import request from '../utils/request';

/**
 * Admin-side wrapper for /api/v1/admin/sms-outreach (guest SMS pipeline
 * analytics + Airflow control). All reads are available to any admin-portal
 * user; trigger/pause/cancel require role=admin server-side.
 *
 * Two Airflow DAGs are exposed: the planner (guest_sms_daily, default) and the
 * dispatcher (guest_sms_dispatch). Pass `dagId` to address the dispatcher.
 */
const BASE = '/admin/sms-outreach';

export const PLANNER_DAG_ID = 'guest_sms_daily';
export const DISPATCH_DAG_ID = 'guest_sms_dispatch';

const dagParams = (dagId) => (dagId ? { dagId } : {});

export const SmsOutreachService = {
  summary: async (params) => (await request.get(`${BASE}/summary`, { params })).data?.summary,
  daily: async (params) => (await request.get(`${BASE}/daily`, { params })).data,
  runs: async (params) => (await request.get(`${BASE}/runs`, { params })).data?.runs || [],
  run: async (runId) => (await request.get(`${BASE}/runs/${encodeURIComponent(runId)}`)).data?.run,
  messages: async (params) => (await request.get(`${BASE}/messages`, { params })).data,
  failures: async (params) => (await request.get(`${BASE}/failures`, { params })).data?.failures,
  conversion: async (params) => (await request.get(`${BASE}/conversion`, { params })).data?.conversion,

  // Planned (scheduled) texts awaiting the dispatcher
  upcoming: async (params) => (await request.get(`${BASE}/upcoming`, { params })).data,
  cancelScheduled: async (id, reason) =>
    (await request.post(`${BASE}/upcoming/${encodeURIComponent(id)}/cancel`, reason ? { reason } : {})).data,

  airflowStatus: async (dagId) => (await request.get(`${BASE}/airflow/status`, { params: dagParams(dagId) })).data,
  airflowTrigger: async ({ mode, note, dagId }) =>
    (await request.post(`${BASE}/airflow/trigger`, { mode, note, ...dagParams(dagId) })).data,
  airflowPause: async (paused, dagId) => (await request.post(`${BASE}/airflow/pause`, { paused, ...dagParams(dagId) })).data,
  airflowTaskLog: async (runId, taskId, tryNumber = 1, dagId) =>
    (
      await request.get(
        `${BASE}/airflow/runs/${encodeURIComponent(runId)}/tasks/${encodeURIComponent(taskId)}/log`,
        { params: { try: tryNumber, ...dagParams(dagId) } }
      )
    ).data?.log,
};

export default SmsOutreachService;
